import { Trophy, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { HONOURS, IMAGES } from "../data/club";

export default function Honours() {
  return (
    <main data-testid="honours-page">
      <Seo
        title="Honours — Whitley Bay Cricket Club"
        description="The trophy cabinet at Whitley Bay CC: NTCL Division 4 North champions 2026 and promoted to Division 3 for 2027, U11 divisional champions, and a women's team on the way in 2027."
      />
      <PageHeader
        eyebrow="The trophy cabinet"
        title="Honours &"
        accent="milestones."
        description="Championships won, promotions earned, and the moments that shaped cricket at West Park."
        image={IMAGES.hero}
        testId="honours-header"
      />
      <section className="max-w-5xl mx-auto px-5 sm:px-8 pb-24">
        <div className="relative border-l border-[#E5AC3C]/30 ml-3 space-y-12">
          {HONOURS.map((h, i) => (
            <Reveal key={h.title} delay={i * 0.1}>
              <div className="relative pl-10" data-testid={`honours-item-${i}`}>
                <span className="absolute -left-[13px] top-1 w-6 h-6 rounded-full bg-[#0B1520] border-2 border-[#E5AC3C] flex items-center justify-center">
                  <Trophy size={11} className="text-[#E5AC3C]" />
                </span>
                <span className="text-xs font-mono-club uppercase tracking-[0.2em] text-[#5C7285]">{h.year} · {h.team}</span>
                <h2 className="mt-2 font-head text-xl sm:text-2xl font-bold tracking-tight">{h.title}</h2>
                <p className="mt-3 text-[#9BB0C1] leading-relaxed max-w-2xl">{h.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 rounded-3xl border border-[#E5AC3C]/30 bg-[#122030] p-8 sm:p-12 text-center">
            <h2 className="font-head text-2xl sm:text-3xl font-extrabold tracking-tight">
              The next chapter is <span className="font-serif-accent font-medium text-[#E5AC3C]">yours to write</span>
            </h2>
            <p className="mt-4 text-[#9BB0C1] max-w-xl mx-auto">
              New players are welcome across every team — from All Stars to the First XI, and our women's team launching in 2027.
            </p>
            <Link to="/contact" data-testid="honours-join-cta" className="mt-7 inline-flex items-center gap-2 bg-[#E5AC3C] hover:bg-[#F3C35B] text-[#0B1520] font-bold px-7 py-3.5 rounded-full text-sm transition-colors">
              Join the club <ArrowRight size={15} />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
